import { CellContentPosition, Table, TableColumnData, TableProps } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useMemo, useRef } from "react"
import { CompilationModel } from "@tm/data/compilations"
import { isWM } from "@bundles/compilations/utils"
import { CompilationsListItem } from "./CompilationsListItem"

type Props = {
    compilations: CompilationModel[]
    onOpenCompilationDetails(id: string): void
}

export function ExpandedCompilationsList({ compilations, onOpenCompilationDetails }: Props) {
    const { translateText } = useLocalization()
    const tableRef = useRef<HTMLDivElement>(null)

    const tableData: TableProps = useMemo(() => {
        const columns: TableColumnData[] = [
            { header: translateText(155) }, // Table name
            { header: translateText(617) }, //  Description
        ]
        if (isWM()) {
            columns.push({ header: translateText(1243) }) // privacy
        }
        columns.push(
            { header: translateText(258) }, // creation date
            { header: translateText(1252) }, // modification date
            { alignContent: CellContentPosition.right } // Actions
        )
        return {
            scrollbar: "system",
            headerStyle: "default",
            headerBackground: "inherit",
            columns,
        }
    }, [translateText])

    return (
        <Table {...tableData} ref={tableRef} headerBackground="inherit" overflowY="auto">
            {compilations.map((compilation) => (
                <CompilationsListItem compilation={compilation} key={compilation.id} onOpenCompilationDetails={onOpenCompilationDetails} />
            ))}
        </Table>
    )
}
